module.exports = __webpack_public_path__ + "img/1-en.a21d7300.png";